
  const VAPID_PUBLIC_KEY = 'BN_yPhBoMOmRw_oC8BROlMNFi88L2WybfWot69HooxrtGsaELizILKLDOf19Sj_137Q-BdIxoJ7UUCzfc7TyjgE';

  function b64urlToUint8(str) {
    const b64 = str.replace(/-/g, '+').replace(/_/g, '/');
    const raw = atob(b64);
    return Uint8Array.from(raw, c => c.charCodeAt(0));
  }

  async function subscribePush(userId) {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;

    const reg = await navigator.serviceWorker.ready;
    let sub = await reg.pushManager.getSubscription();

    if (!sub) {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: b64urlToUint8(VAPID_PUBLIC_KEY),
      });
    }

    const json = sub.toJSON();
    await window.sb.from('push_subscriptions').upsert({
      endpoint: json.endpoint,
      p256dh:   json.keys.p256dh,
      auth:     json.keys.auth,
      user_id:  userId,
    }, { onConflict: 'endpoint' });
  }

  async function initPwa(profile) {
    if (!('serviceWorker' in navigator)) return;

    await navigator.serviceWorker.register('/sw.js');

    const perm = await Notification.requestPermission();
    if (perm !== 'granted') return;

    await subscribePush(profile.id);
  }

  // Hookeia no evento de auth já existente
  const _prevOnAuthReady = window.onAuthReady;
  window.onAuthReady = async function(profile) {
    if (_prevOnAuthReady) await _prevOnAuthReady(profile);
    initPwa(profile).catch(e => console.warn('PWA init error:', e));
  };

  // Se já logado quando o script carrega
  if (window.currentProfile) {
    initPwa(window.currentProfile).catch(e => console.warn('PWA init error:', e));
  }
